import React, { useContext } from 'react';
import { ReactElement } from 'react';
import { TabsContext } from './TabsContext';

export const TabPanels = ({ children }: { children: ReactElement[] }) => {
  const { selectedTab } = useContext(TabsContext);

  return <>{children.filter((_child, index) => index === selectedTab)}</>;
};
